import styled from "styled-components";
import { colors } from "../../../styles/figmaColors";
import { TagOrBadge } from "../Tag/TagOrBadge";
import { RowElement } from "../RowElement/RowElement";
import { Avatar } from "../Avatar/Avatar";
import Car from "../../assets/Car.png";
import { typographies } from "../../../styles/figmaTypographies";
import { NearMeOutlined } from "../../materialUi/materialUi";
import { Spacer } from "../Spacer";

export interface CardVehicleAndDriverProps {
  onClick: () => void;
  vehicle?: {
    uuid: string;
    registrationNumber: string;
    model?: string;
    lastLatitude: number;
    lastLongitude: number;
  };
  driver?: {
    firstName: string;
    lastName: string;
    phone: string;
  };
  distance: number;
  badgeText?: string;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  $withShadow?: boolean;
  rightElement?: JSX.Element;
}

export const CardVehicleAndDriver = (props: CardVehicleAndDriverProps) => {
  const {
    vehicle,
    driver,
    distance,
    onClick,
    badgeText,
    onMouseEnter,
    onMouseLeave,
    $withShadow,
    rightElement,
  } = props;
  return (
    <StyledCard
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      $withShadow={$withShadow}
    >
      <StyledFrameElement>
        {vehicle && (
          <RowElement
            backgroundColor={
              colors["colors/surfaces/background/background_level2,5"]
            }
            size="L"
            text={
              <StyledVehicleName>
                {vehicle.registrationNumber}
              </StyledVehicleName>
            }
            onClickRow={() => onClick()}
            tagOrBadge={
              badgeText ? (
                <TagOrBadge
                  text={badgeText}
                  type="BADGE"
                  backgroundColor={
                    colors["colors/system/informative/informative_veryLight"]
                  }
                  textColor={colors["colors/text/darkGrey"]}
                />
              ) : undefined
            }
            rightElementText={
              <StyledRightElementText>
                <>
                  {rightElement ? (
                    rightElement
                  ) : (
                    <>
                      <StyledNearMe>
                        <NearMeOutlined />
                      </StyledNearMe>
                      <Spacer x={0.2} />
                      {distance ? distance.toFixed(1) : "-"} km
                    </>
                  )}
                </>
              </StyledRightElementText>
            }
            subText={
              vehicle.model ? (
                <StyledVehicleSubText>{vehicle.model}</StyledVehicleSubText>
              ) : undefined
            }
            leftIcon={<StyledImg src={Car} alt="Car" />}
            withoutBorder
            widthPercentageRightElementText={35}
          />
        )}
        {driver && (
          <RowElement
            backgroundColor={
              colors["colors/surfaces/background/background_level2,5"]
            }
            size="L"
            text={
              <StyledDriverName>
                {driver.firstName} {driver.lastName}
              </StyledDriverName>
            }
            onClickRow={() => onClick()}
            leftIcon={
              <Avatar
                size="S"
                color="blue"
                firstName={driver.firstName}
                lastName={driver.lastName}
              />
            }
            subText={<StyledDriverPhone>{driver.phone}</StyledDriverPhone>}
            withoutBorder
          />
        )}
      </StyledFrameElement>
    </StyledCard>
  );
};

const StyledVehicleName = styled.div`
  color: ${colors["colors/text/black"]};
  ${typographies["Body/M"]}
`;

const StyledVehicleSubText = styled.div`
  color: ${colors["colors/text/darkGrey"]};
  ${typographies["Body/XXS"]}
`;

const StyledDriverName = styled.div`
  color: ${colors["colors/text/black"]};
  ${typographies["Body/S"]}
`;

const StyledDriverPhone = styled.div`
  color: ${colors["colors/text/darkGrey"]};
  ${typographies["Body/XXS"]}
`;

const StyledRightElementText = styled.div`
  color: ${colors["colors/text/lightGrey"]};
  ${typographies["Body/XXXS"]}
  display: flex;
  align-items: center;
  .svg
`;

const StyledCard = styled.div<{ $withShadow?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: max-content;
  border: 1px solid ${colors["colors/surfaces/background/background_level2,5"]};
  border-radius: 0.5rem;
  background-color: ${colors["colors/surfaces/background/background_level2,5"]};
  box-shadow: ${({ $withShadow }) =>
    $withShadow ? "0px 4px 16px 0px rgba(51, 51, 51, 0.15)" : "none"};
  &:hover {
    box-shadow: 0px 4px 16px 0px rgba(51, 51, 51, 0.15);
    cursor: pointer;
  }
`;

const StyledFrameElement = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledImg = styled.img`
  display: flex;
  align-items: center;
  justify-content: center;
  filter: grayscale(100%);
  width: 2rem;
`;

const StyledNearMe = styled.div`
  display: flex;
  & svg {
    width: 1rem;
    height: 1rem;
    fill: ${colors["colors/text/lightGrey"]};
  }
`;
